import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "../queries/auth.queries";

export default function VerificationRoute() {
	const { data: session } = useSession();
	const location = useLocation();

	if (
		session?.user_verified &&
		!session?.company_verified &&
		session?.user_role === "owner"
	) {
		return <Outlet />;
	}

	return <Navigate to="/login" state={{ from: location }} replace />;
}
